import {Component, ViewChild} from '@angular/core';
import {executeWithLoader, LoaderStatus} from '../utils/loader.util';
import {AnalyticsTracker} from '../utils/AnalyticsTracker';
import {Router} from '@angular/router';
import {NomineeService} from '../service/nominee.service';
import {ConfirmPopUpComponent} from '../comfirm-pop-up/confirm-pop-up.component';
import {Keys, StorageService} from '../service/storage.service';
import {MatDialog} from '@angular/material';
import {isEmpty} from 'lodash';
import {NomineeFormComponent} from "./nominee-form/nominee-form.component";

@Component({
    selector: 'app-lender-nominee',
    templateUrl: './lender-nominee.component.html',
    styleUrls: [],
    providers: [NomineeService]
})
export class LenderNomineeComponent {

    @ViewChild(NomineeFormComponent)
    nomineeFormComponent: NomineeFormComponent;
    loaderStatus = new LoaderStatus();

    public readonly analyticsTracker: AnalyticsTracker;

    private readonly router: Router;
    private readonly dialog: MatDialog;
    private readonly storageService: StorageService;

    constructor(router: Router, dialog: MatDialog, analyticsTracker: AnalyticsTracker, storageService: StorageService) {
        this.dialog = dialog;
        this.router = router;
        this.storageService = storageService;
        this.analyticsTracker = analyticsTracker;
    }

    public async onSubmit(): Promise<void> {
        if (this.nomineeFormComponent.isFormValid()) {
            if (this.nomineeFormComponent.validateTermsCheck()) {
                await executeWithLoader(this.loaderStatus, async () => {
                    await this.nomineeFormComponent.saveForm();
                    await this.storageService.saveItem(Keys.LENDER_NOMINEE, 'true');
                    this.analyticsTracker.trackButtonClick('Nominee Information', 'Next');
                    await this.navigateToNextStep();
                });
            }
            return;
        }
        const dialogRef = this.dialog.open(ConfirmPopUpComponent, {
            data: {
                title: 'Nominee details are incomplete',
                message: 'Some of the required information is not filled and nominee information will not be saved. Would you like to complete this to add a nominee?',
                positiveButtonText: 'COMPLETE NOMINEE DETAILS',
                negativeButtonText: 'SKIP THIS STEP',
            },
            disableClose: true
        });
        const dialogResult = await dialogRef.afterClosed().toPromise();
        if (!dialogResult) {
            await this.navigateToNextStep();
        }
    }

    backLink(): string {
        return '/lenderbankdetails';
    }

    forwardLink(): string {
        return '/invest/investment-preferences';
    }

    async navigateToNextStep() {
        await this.router.navigate([this.forwardLink()]);
    }


    public isNextEnabled(): boolean {
        if(this.nomineeFormComponent) {
            return !isEmpty(this.nomineeFormComponent.prefilledNominee) || this.nomineeFormComponent.nomineeForm.dirty;
        }
    }
}
